import { render, staticRenderFns } from "./BarCodeScanner.vue?vue&type=template&id=07a3369e&"
import script from "./BarCodeScanner.vue?vue&type=script&lang=js&"
export * from "./BarCodeScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports